function datePick() {

    let calendar  = $('._js-input-date');

    const dateFormat = "dd.mm.yyyy";
    const options = {
        defaultDate: "+1w",
        changeMonth: true,
        changeYear: true,
        numberOfMonths: 1,
        dateFormat: dateFormat,
        monthNamesShort: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь"
        ],
        dayNamesMin: ["Вск", "Пн", "Вт", "Ср", "Чт", "Птн", "Сб"],
        firstDay: 1,
        onSelect(formattedDate, date, inst) {
            inst.$el.val(formattedDate);
            inst.$el.trigger('change');
        }
    };

    if ( calendar.length) {
        calendar.datepicker(options)
            .on( "change", function() {
              // calendar.data('datepicker').selectDate(this.value)
            });

        /*$('body').on('scroll', function(){
            $('._js-input-date').datepicker('hide').blur();
        });

        $(window).on('resize', function(){
            $('._js-input-date').datepicker('hide').blur();
        });*/

    }

    let birthCalendar = $('._js-input-birth-date');
    if (birthCalendar.length) {
        options.yearRange = "1920:+00";
        options.defaultDate = "-20y";
        birthCalendar.datepicker(options)
            .on( "change", function() {
                // birthCalendar.datepicker( "option" );
            });

        $('body').on('scroll', function(){
            $('._js-input-birth-date').datepicker('hide').blur();
        });

        $(window).on('resize', function(){
            $('._js-input-birth-date').datepicker('hide').blur();
        });
    }
}
